<template>
  <div id="container" class="member_st">
    <!-- 개인정보수정 & sub menu -->
    <AccountHead :current-tab="currentTab" />

    <div class="section fill">
      <div class="inner delivery_detail order">
        <div class="box_title">
          <h2 v-if="currentTab == 'orders'">주문 상세내역</h2>
          <h2 v-if="currentTab == 'returns'">취소 상세내역</h2>
          <!-- <p class="guide_txt">{{ $t('views.member.orderdetail.637') }}</p>-->
        </div>

        <div v-if="order" class="mypage_detail book_num">
          <div class="box">
            <div class="order_title">
              <dl>
                <dt>{{ $t('views.member.orderdetail.6084') }}</dt>
                <dd>
                  <span>{{ order.orderDtime | timestamp }}</span>
                </dd>
              </dl>
              <dl>
                <dt>{{ $t('views.member.orderdetail.822') }}</dt>
                <dd>
                  <span class="num">{{ order.orderCd }}</span>
                </dd>
              </dl>
            </div>
            <ul class="order_book">
              <li v-for="(item, idx) in order.orderGoodsList" :key="idx">
                <div class="cover_wrap">
                  <router-link
                    :to="{
                      name:
                        item.bookTp === 'EBOOK'
                          ? 'library_book_detail'
                          : 'book_detail',
                      params: { id: item.bookCd }
                    }"
                    class="thum_wrap"
                  >
                    <img :src="item.thumbUrl" :alt="item.bookNm" />
                  </router-link>
                </div>
                <div class="info_wrap">
                  <cite class="meta_title">{{ item.bookNm }}</cite>
                  <p>
                    <span class="meta_author">{{ item.author }}</span>
                    <span class="gap">/</span>
                    <span class="meta_publisher">{{ item.publisher }}</span>
                  </p>
                  <p>
                    <span class="meta_type">{{ item.bookTp }}</span>
                  </p>
                  <p>
                    <span class="meta_num">
                      {{ $t('views.member.orderdetail.total') }}
                      <span class="num">{{ item.units }}</span>
                      {{ $t('views.member.orderdetail.books') }}
                    </span>
                    <del v-if="item.couponDiscount > 0" class="list_price">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        format-style="currency"
                        :currency="item.currencyTp"
                        :number="item.listPrice"
                      />
                    </del>
                    <span v-if="item.couponDiscount > 0" class="percent">
                      ({{
                        Math.round(
                          ((item.listPrice - item.saleAmt) / item.listPrice) *
                            100
                        )
                      }}%
                      <span class="arrow"></span>
                      )
                    </span>
                    <span v-if="item.saleAmt">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="item.currencyTp"
                        :number="item.saleAmt"
                      />
                    </span>
                    <span v-if="!item.saleAmt">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="item.currencyTp"
                        :number="0"
                      />
                    </span>
                  </p>
                </div>
                <!-- <div v-show="item.menuShowYn === 'Y'" class="btn_wrap"> -->
                <div v-if="currentTab == 'orders'" class="btn_wrap">
                  <div class="cell">
                    <p class="state_txt" :class="{ c_black: item.deliveryMsg }">
                      {{
                        item.ebookOrders && item.ebookOrders.ebookOptNm
                          ? item.ebookOrders.ebookOptNm
                          : item.purchaseTp === 'PRS'
                          ? '증정본'
                          : '선물'
                      }}
                      <span
                        v-if="
                          item.ebookOrders &&
                          item.ebookOrders.ebookOptNm === '완전구매'
                        "
                        class="have_type"
                      >
                        (소장)
                      </span>
                      <span
                        v-if="
                          item.ebookOrders &&
                          item.ebookOrders.ebookOptNm === '대여'
                        "
                        class="have_type"
                      >
                        (대여)
                      </span>
                      <span
                        v-if="
                          (item.ebookOrders &&
                            item.ebookOrders.ebookOptNm === '선물') ||
                          (!item.ebookOrders && item.purchaseTp !== 'PRS')
                        "
                        class="have_type"
                      >
                        (선물)
                      </span>
                    </p>
                    <!-- <router-link
                      v-if="!item.buyTp.ebook"
                      :to="{
                        name: 'order_tracking',
                        params: { id: order.orderCd, order }
                      }"
                      class="box_btn dull"
                      :class="{ none: order.delivery.trackingYn === 'N' }"
                    >
                      <span class="an_t">
                        {{ $t('views.member.orderdetail.5638') }}
                      </span>
                    </router-link> -->
                  </div>

                  <!-- <div class="cell">
                    <template v-if="item.deliveryMsg !== '반품 요청 중'">
                      <a
                        v-if="!item.buyTp.ebook"
                        class="box_btn max cancel_button"
                        :class="{ none: item.cancelYn === 'N' }"
                        @click="toggleCancelOrderModal"
                      >
                        <span class="an_t">
                          {{ $t('views.member.orderdetail.4762') }}
                        </span>
                      </a>
                      <router-link
                        v-if="!item.buyTp.ebook && currentTab !== 'returns'"
                        :to="{
                          name: 'request_return',
                          params: { id: order.orderCd, item, order }
                        }"
                        :class="{
                          none: item.returnYn === 'N'
                        }"
                        class="box_btn line return_button"
                      >
                        <span class="an_t">
                          {{ item.returnYnMsg }}
                        </span>
                      </router-link>
                    </template>
                    <template v-else>
                      <button
                        type="submit"
                        class="box_btn line"
                        @click="toggleCancelReturnModal"
                      >
                        <span class="an_t">
                          {{ $t('views.member.orderdetail.6449') }}
                        </span>
                      </button>
                    </template>
                  </div> -->
                </div>
              </li>
            </ul>
          </div>
          <div v-if="order.purchaseTp === 'GFT'" class="box delivery_info">
            <div class="top_title">
              <p>선물 정보</p>
            </div>

            <div class="receiver_wrap fl">
              <dl>
                <dt>{{ $t('views.member.orderdetail.4683') }}</dt>
                <dd>
                  <span class="meta_name">
                    {{ order.giftName || '' }}
                  </span>
                </dd>
                <dt>{{ $t('views.member.orderdetail.6127') }}</dt>
                <dd>
                  <span class="meta_phone">{{ order.giftMobileNo || '' }}</span>
                </dd>
                <dt>{{ $t('views.member.orderdetail.7730') }}</dt>
                <dd>
                  <!-- <span class="meta_zipcode">{{
                    order.delivery ? order.delivery.zipCd : ''
                  }}</span
                  ><br /> -->
                  <span class="meta_address">{{ order.giftEmail || '' }}</span>
                </dd>
                <dt>선물사용 여부</dt>
                <dd>
                  <span class="meta_messagge">
                    {{ `사용완료( ${order.giftConfirmDtime} )` || '미사용' }}
                  </span>
                </dd>
              </dl>
            </div>
          </div>

          <div class="box payment_info">
            <div class="top_title">
              <p>결제 정보</p>
            </div>
            <div class="receiver_wrap fl line_none">
              <dl>
                <dt>결제수단</dt>
                <dd>
                  <span class="pay_type">
                    {{ order.provider }}
                  </span>
                </dd>
              </dl>
              <div class="btn_wrap">
                <div class="cell">
                  <a class="box_btn line" @click="showReceipt">
                    <span class="an_t">영수증</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="receiver_wrap fl">
              <dl>
                <dt>총 상품 가격</dt>
                <dd>
                  <span>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="meta-price"
                      format-style="currency"
                      :currency="order.currencyTp"
                      :number="totalGoodsPrice"
                    />
                  </span>
                </dd>
                <dt>쿠폰 할인 가격</dt>
                <dd>
                  <span>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="meta-price"
                      format-style="currency"
                      :currency="order.currencyTp"
                      :number="order.discountTotal"
                    />
                  </span>
                </dd>
                <dt>총 결제 금액</dt>
                <dd>
                  <span>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="meta_price"
                      format-style="currency"
                      :currency="order.currencyTp"
                      :number="order.saleTotal"
                    />
                  </span>
                </dd>
              </dl>
            </div>
          </div>
          <div v-if="currentTab == 'returns'" class="box payment_info">
            <div class="top_title">
              <p>환불 정보</p>
            </div>
            <div class="receiver_wrap fl line_none">
              <dl>
                <dt>결제수단</dt>
                <dd>
                  <span class="pay_type">
                    {{ order.provider }}
                  </span>
                </dd>
              </dl>
              <p class="ment">
                정확한 환불 완료일은 결제하신 수단을 통해 확인하실 수 있습니다.
                <br />
                자세한 사항은 해당 결제 수단 고객센터로 문의해 주세요.
              </p>
            </div>
            <div class="receiver_wrap fl">
              <dl>
                <dt>환불금액</dt>
                <dd>
                  <span>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="meta-price"
                      format-style="currency"
                      :currency="order.currencyTp"
                      :number="order.saleTotal"
                    />
                  </span>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="btn_wrap list_btn">
          <router-link
            v-if="currentTab == 'orders'"
            :to="{ name: 'orders' }"
            class="box_btn"
          >
            <span class="an_t">주문 목록</span>
          </router-link>
          <router-link
            v-if="currentTab == 'returns'"
            :to="{ name: 'returns' }"
            class="box_btn"
          >
            <span class="an_t">취소 목록</span>
          </router-link>
        </div>
      </div>
    </div>

    <!-- ****************** -->
    <!-- CANCEL ORDER MODAL -->
    <!-- ****************** -->
    <transition name="modal-fade">
      <Modal v-if="showCancelOrderModal" @close="toggleCancelOrderModal">
        <div class="ly_pop_content ly_pop_msg ly_txt">
          <div class="ly_pop_head">
            <a class="btn_ly_close svg_close" @click="toggleCancelOrderModal">
              <span>{{ $t('library.deletemodal.close') }}</span>
            </a>
          </div>
          <div class="ly_inner cancel_model">
            <p class="tac">
              {{ $t('views.member.orderdetail.6625', { '1': order.orderCd }) }}
            </p>
            <p class="tac">{{ $t('views.member.orderdetail.82') }}</p>
            <div class="btn_wrap">
              <button
                class="ModalBtn box_btn dull"
                @click="toggleCancelOrderModal"
              >
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </button>
              <button class="ModalBtn box_btn" @click="cancelOrder">
                <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </transition>

    <!-- ****************** -->
    <!-- CANCEL RETURN ORDER MODAL -->
    <!-- ****************** -->
    <transition name="modal-fade">
      <Modal v-if="showCancelReturnModal" @close="toggleCancelReturnModal">
        <div class="ly_pop_content ly_pop_msg ly_txt">
          <div class="ly_pop_head">
            <a class="btn_ly_close svg_close" @click="toggleCancelReturnModal">
              <span>{{ $t('library.deletemodal.close') }}</span>
            </a>
          </div>
          <div class="ly_inner">
            <p class="tac">{{ $t('views.member.orderdetail.9997') }}</p>
            <!-- If order is  7 days+ old, show this -->
            <!-- No, just prevent the u -->
            <!-- <p class="tac">{{ $t('views.member.orderdetail.148') }}</p> -->

            <div class="btn_wrap">
              <button
                class="ModalBtn box_btn dull"
                @click="toggleCancelReturnModal"
              >
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </button>
              <a class="ModalBtn box_btn" @click="cancelReturnOrder">
                <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </transition>

    <!-- Message MODAL -->
    <transition v-on-clickaway="toggleMessageModal" name="modal-fade">
      <Modal v-if="showMessageModal" @close="toggleMessageModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleMessageModal">
                <span>{{ $t('library.deletemodal.close') }}</span>
              </a>
            </div>
            <div class="ly_inner">
              <p>
                {{ message }}
              </p>
              <div class="btnWrap">
                <button class="box_btn w-full" @click="toggleMessageModal">
                  <span class="an_t">
                    {{ $t('library.deletemodal.close') }}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import AccountHead from '@/components/member/AccountHead.vue'
import { ACCOUNT_ORDER_CANCEL } from '@/store/types'
import { mapGetters } from 'vuex'

export default {
  name: 'OrderDetail',

  components: {
    AccountHead
  },
  data() {
    return {
      showMessageModal: false,
      showSellerInfoModal: false,
      showCancelOrderModal: false,
      showCancelReturnModal: false,
      showErrorModal: false,
      order: null,
      message: '',
      currentTab: ''
    }
  },
  computed: {
    ...mapGetters(['getCurrency']),
    totalGoodsPrice() {
      return this.order.orderGoodsList.reduce(
        (total, item) => total + item.listPrice,
        0
      )
    }
  },
  mounted() {
    if (!this.$route.params.order) {
      this.$router.push({ name: 'orders' })
    } else {
      this.order = this.$route.params.order
    }

    if (this.$route.params.currentTab) {
      this.currentTab = this.$route.params.currentTab
    }
  },
  methods: {
    toggleMessageModal(message) {
      this.showMessageModal = !this.showMessageModal
      if (this.showMessageModal && message) {
        this.message = message
      }
    },
    toggleCancelOrderModal() {
      this.showCancelOrderModal = !this.showCancelOrderModal
    },
    toggleCancelReturnModal() {
      this.showCancelReturnModal = !this.showCancelReturnModal
    },
    async cancelOrder() {
      const id = this.order.orderCd
      try {
        await this.$store.dispatch(ACCOUNT_ORDER_CANCEL, id)
        this.toggleCancelOrderModal()
        this.$router.push({ name: 'returns' })
      } catch (err) {
        this.toggleCancelOrderModal()
        this.toggleMessageModal(
          `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
        )
      }
    },
    showReceipt() {
      window.open(this.order.orderGoodsList[0].receiptUrl, '_blank')
    }
  }
}
</script>
<style src="@/assets/css/page_member.css" scoped></style>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
.member_st .box_btn.line {
  border-radius: 7px;
  background: #000000cc;
}
.member_st .box_btn.line .an_t {
  font-family: 'pretendard-light';
  color: #fff;
}
.delivery_detail.order .box.payment_info .btn_wrap {
  top: 0;
  bottom: auto;
  right: 40px;
}
.ModalBtn {
  margin-left: 6px !important;
  margin-right: 6px !important;
  padding: 20px 25px !important;
  .an_t {
    font-size: 16px !important;
    line-height: 1px !important;
  }
}
.order_book .info_wrap .meta_title {
  display: block;
  height: auto;
}
.ment {
  margin-top: 10px;
  line-height: 17px;
}
.list_price {
  margin-left: 7px;
  color: #778899;
}
.percent {
  color: #778899;
  .arrow {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m8.672 4.964v1.494l-3.654 2.52-3.69-2.52v-1.494l2.988 1.926v-5.868h1.386v5.868z' fill='%23f00'/%3E%3C/svg%3E%0A");
    background-position: center center;
    background-repeat: no-repeat;
  }
}
.none {
  pointer-events: none;
}
.delivery_info {
  .receiver_wrap.fl {
    dd {
      width: 100%;
    }
  }
}
.delivery_detail .box .fl {
  height: inherit;
}
.cancel_button {
  display: block;
  width: 50%;
  margin: auto;
}
.return_button {
  display: block;
  width: 50%;
  margin: auto;
}
.ly_inner.cancel_modal {
  padding-left: 45px;
  padding-right: 45px;
}
.list_btn {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.delivery_detail.order > .btn_wrap .box_btn .an_t {
  line-height: 46px;
}
.have_type {
  display: block;
}
.member_st .gap {
  float: none;
}
.delivery_detail.order .box.payment_info .fl {
  min-height: 170px;
  height: auto;
}
.delivery_detail.order .box.payment_info .fl.line_none dl {
  display: flex;
}
.delivery_detail.order .box.payment_info .receiver_wrap dl dd:last-child {
  margin-bottom: 0;
}
.delivery_detail.order .box.payment_info .receiver_wrap dl dt::before {
  top: -25px;
}
.receiver_wrap.line_none dl dt {
  width: 70px;
}
@media (max-width: 767px) {
  .mypage_detail .state_txt {
    top: 65px;
  }
  .delivery_detail.order .box.payment_info .receiver_wrap dl dt::before {
    top: 0;
  }
  .delivery_detail.order .box.payment_info .receiver_wrap .btn_wrap {
    margin-top: 12px;
  }
  .delivery_detail.order .box.payment_info .receiver_wrap .box_btn {
    width: auto;
    height: 29px;
    padding: 0px 11px;
  }
  .delivery_detail.order .box.payment_info .fl {
    min-height: auto;
  }
  .member_st .box_btn.line .an_t {
    font-size: 12px;
    line-height: 28px;
  }
  .list_btn {
    flex-direction: column;
    align-items: center;
  }
}
@media (max-width: 500px) {
  .order_book .info_wrap {
    width: auto;
  }
  .mypage_detail .state_txt {
    top: 85px;
  }
}
</style>
